// ccp/src/lib/acw.js
//
// D32 (2026-09-14): after-call-work timing, in one place. While a wrap-up is
// unsaved Connect holds the agent at 0 slots on EVERY channel (measured
// 2 h 57 m live). The console cannot detect a crashed tab — the sweeper does
// that server-side — but it can make the time visible from the first second
// and turn urgent at the same threshold the server alerts on.
//
// ACW_ALERT_MINUTES mirrors the sweeper's ACW_ALERT_MINUTES (5). Keep them
// aligned when either changes.

export const ACW_ALERT_MINUTES = 5;

export function acwElapsedSeconds(startedAt, now = Date.now()) {
  const t = Number(startedAt);
  if (!Number.isFinite(t) || t <= 0) return 0;
  return Math.max(0, Math.floor((now - t) / 1000));
}

export function isAcwUrgent(startedAt, now = Date.now()) {
  return acwElapsedSeconds(startedAt, now) >= ACW_ALERT_MINUTES * 60;
}

// m:ss below an hour, h:mm:ss after.
export function fmtClock(seconds) {
  const s = Math.max(0, Math.floor(Number(seconds) || 0));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const ss = s % 60;
  const pad = n => String(n).padStart(2, '0');
  return h > 0 ? `${h}:${pad(m)}:${pad(ss)}` : `${m}:${pad(ss)}`;
}

// Best available "entered ACW at" for a Streams contact: the ended-state
// timestamp Streams carries (survives a reload), else now.
export function acwStartedAtFor(contact, now = Date.now()) {
  try {
    const ts = contact?.getStatus?.()?.timestamp;
    const t = ts instanceof Date ? ts.getTime() : Number(ts);
    if (Number.isFinite(t) && t > 0) return t;
  } catch { /* fall through */ }
  return now;
}
